import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";

const Subscriptions = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [rows, setRows] = useState([
        {
            id: 1,
            type: "Freemium",
            planName: "Basic Plan",
            validity: "30 Days",
            price: "Free",
            benefits: ["Limited Access", "Basic Support"],
        },
        {
            id: 2,
            type: "Premium",
            planName: "Pro Plan",
            validity: "90 Days",
            price: "$29.99",
            benefits: ["All Features", "Priority Support", "No Ads"],
        },
        {
            id: 3,
            type: "Premium",
            planName: "Enterprise Plan",
            validity: "1 Year",
            price: "$99.99",
            benefits: ["Custom Features", "Dedicated Manager", "24/7 Support"],
        },
    ]);



    return (
        <>
            <div className="main_title">
                <h1>Manage Subscriptions</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Subscriptions
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search Subscription Plans..."
                        />
                    </div>
                    <div className="right_s">
                        <Button
                            variant="contained"
                            className="btn btn_primary"
                            onClick={() => navigate("/subscription/edit")}
                        >
                            <AddIcon /> Add Subscription
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Subscription Type</TableCell>
                                <TableCell>Plan Name</TableCell>
                                <TableCell>Validity</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Benefits</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows
                                .filter(
                                    (row) =>
                                        row.planName
                                            .toLowerCase()
                                            .includes(searchTerm.toLowerCase()) ||
                                        row.type.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((row, index) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{row.type}</TableCell>
                                        <TableCell>{row.planName}</TableCell>
                                        <TableCell>{row.validity}</TableCell>
                                        <TableCell>{row.price}</TableCell>
                                        <TableCell>
                                            {row.benefits.map((b, i) => (
                                                <div key={i}>• {b}</div>
                                            ))}
                                        </TableCell>
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <IconButton
                                                    onClick={() => navigate("/subscription/edit")}
                                                >
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                                <IconButton
                                                    onClick={() => navigate("/subscription/view")}
                                                >
                                                    <img src="/static/images/eye_icon.svg" alt="Edit" />
                                                </IconButton>
                                                <IconButton
                                                >
                                                    <img src="/static/images/trash2_icon.svg" alt="Edit" />
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default Subscriptions;
